module.exports = __webpack_public_path__ + "static/media/empty_state_pix.1e92cd78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/empty_state_pix.svg
// module id = 2752
// module chunks = 0